import { pickemUserPath } from "pages/PageConfigs";
import { useNavigate } from "react-router-dom";
import { selectUsername } from "selectors/User";
import {
  LeaderboardCell,
  LeaderboardRow,
  UsernameCell,
  TightLeaderboardCell,
  TotalLeaderboardCell,
} from "./styles";
import { TournamentLeaderboardUser } from "model/Leaderboard/User/TournamentLeaderboardUser";
import { useAppSelector } from "app/hooks";

interface Props {
  leaderboardUser: TournamentLeaderboardUser;
  segmentIds: string[];
  highlight: boolean;
  seperate?: boolean;
  hideBottomBorder?: boolean;
  showTotalColumn?: boolean;
}

export const TournamentPickemLeaderboardRow = ({
  leaderboardUser,
  segmentIds,
  highlight,
  seperate,
  hideBottomBorder,
  showTotalColumn,
}: Props) => {
  const uid = leaderboardUser.uid;
  const username = useAppSelector((state) => selectUsername(state, uid));
  const navigate = useNavigate();
  const toPickemUser = () => {
    navigate(`${pickemUserPath}/${uid}`);
  };

  return (
    <LeaderboardRow
      highlight={highlight}
      hideBottomBorder={hideBottomBorder ?? false}
      thickBorder={seperate ?? false}
      onClick={toPickemUser}
    >
      <TightLeaderboardCell>{leaderboardUser.rank}</TightLeaderboardCell>
      <UsernameCell>{username}</UsernameCell>
      {(showTotalColumn ?? true) && (
        <TotalLeaderboardCell>{leaderboardUser.points}</TotalLeaderboardCell>
      )}
      {segmentIds.map((segmentId) => (
        <LeaderboardCell key={segmentId}>
          {getPointsString(
            leaderboardUser.segments.find((s) => s.segmentId === segmentId)
              ?.points
          )}
        </LeaderboardCell>
      ))}
    </LeaderboardRow>
  );
};

const getPointsString = (points: number | undefined) => {
  if (points === undefined) {
    return "-";
  }

  return points.toString();
};
